


















import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Confirm extends Vue {
  @Model('change') public modelData!: boolean;

  // 弹窗标题
  @Prop() public title!: string;

  // 弹窗内容
  @Prop() public content!: string;

  // 加载中状态
  @Prop({ type: Boolean, default: false }) public loading!: string;

  // 禁用确定按钮
  @Prop({ type: Boolean, default: false }) public disableSubmit!: string;

  // 为 true 时点击元素外面或按下 esc 键将不会关闭它
  @Prop({ type: Boolean, default: true }) public persistent!: boolean;

  // 弹窗宽度
  @Prop({ type: [Number, String], default: 300 }) public width!: string;

  public get visible() {
    return this.modelData || false;
  }

  public set visible(visible: boolean) {
    this.$emit('change', visible);
  }

  // 禁用确定按钮
  public get disSubmit() {
    return this.disableSubmit || this.loading;
  }

  @Emit('confirm')
  public onCancel() {
    return false;
  }

  @Emit('confirm')
  public onSubmit() {
    return true;
  }
}
